import { render } from "./NotFoundPage.vue?vue&type=template&id=1cc7ce6e&ts=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__